import { render, staticRenderFns } from "./SailCroatiaBody.vue?vue&type=template&id=4f11a44b&scoped=true&"
import script from "./SailCroatiaBody.vue?vue&type=script&lang=ts&"
export * from "./SailCroatiaBody.vue?vue&type=script&lang=ts&"
import style0 from "./SailCroatiaBody.vue?vue&type=style&index=0&id=4f11a44b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11a44b",
  null
  
)

export default component.exports